import {gql} from "@apollo/client";

export const GET_ALL_AGENTS = gql`
    query GetAllAgents {
        agents(pagedInput: {
            pageInfo: {
                pageIndex: 0,
                pageSize: 1000
            },
            orderAsc: true,
            orderField: "lastName",
            filter: {}
        }) {
            items {
                id
                firstName
                lastName
                email
            }
        }
    }
`;

export const GET_AGENTS = gql`
    query GetAgents($pageIndex: Int!, $pageSize: Int!, $orderAsc: Boolean!, $orderField: String!, $filter: JSON) {
        agents(pagedInput: {
            pageInfo: {
                pageIndex: $pageIndex,
                pageSize: $pageSize
            },
            orderAsc: $orderAsc,
            orderField: $orderField,
            filter: $filter
          }) {
            items {
                id
                firstName
                lastName
                email
                primaryPhone
                secondaryPhone
                properties {
                    id
                }
                dateStarted
                pprRegistrationNumber
                status
                hasFicaDocument
                hasIdDocument
                hasProofOfAddress
                bankingDetails
                department
            }
            pageInfo {
                totalCount
                totalPages
                pageSize
                pageIndex
            }
        }
    }
`;

export const GET_AGENT = gql`
    query GetAgent($id: ID!) {
        agent(id: $id) {
            id
            firstName
            lastName
            email
            primaryPhone
            secondaryPhone
            dateStarted
            pprRegistrationNumber
            status
            taxNumber
            nextOfKinName
            nextOfKinPhone
            hasFicaDocument
            hasIdDocument
            hasProofOfAddress
            department
            properties {
                id
                address {
                    street
                    suburb
                    city
                    postalCode
                }
                status
            }
            bankingDetails
            bankingDetailsInfo {
                bankName
                accountNumber
                accountType
                branchCode
                accountHolder
            }
            createdAt
            updatedAt
        }
    }
`;

export const CREATE_AGENT = gql`
    mutation CreateAgent($input: AgentInput!) {
        createAgent(inputData: $input) {
            id
            firstName
            lastName
            email
            primaryPhone
            secondaryPhone
            dateStarted
            pprRegistrationNumber
            status
            taxNumber
            nextOfKinName
            nextOfKinPhone
            department
        }
    }
`;

export const UPDATE_AGENT = gql`
    mutation UpdateAgent($id: ID!, $input: AgentInput!) {
        updateAgent(id: $id, inputData: $input) {
            id
            firstName
            lastName
            email
            primaryPhone
            secondaryPhone
            dateStarted
            pprRegistrationNumber
            status
            taxNumber
            nextOfKinName
            nextOfKinPhone
            department
        }
    }
`;

export const DELETE_AGENT = gql`
    mutation DeleteAgent($id: ID!) {
        deleteAgent(id: $id)
    }
`;

export const GET_AGENT_DOCUMENTS = gql`
    query GetAgentDocuments($id: ID!) {
        agent(id: $id) {
            id
            firstName
            lastName
            email
            bankingDetails
            bankingDetailsInfo {
                bankName
                accountNumber
                accountType
                branchCode
                accountHolder
            }
            documents {
                id
                name
                type
                url
                uploadedAt
            }
        }
    }
`;

export const UPLOAD_AGENT_DOCUMENT = gql`
    mutation UploadAgentDocument($agentId: ID!, $file: Upload!, $type: String!) {
        uploadAgentDocument(agentId: $agentId, file: $file, type: $type) {
            id
            name
            type
            url
            uploadedAt
        }
    }
`;

export const DELETE_AGENT_DOCUMENT = gql`
    mutation DeleteAgentDocument($id: ID!) {
        deleteAgentDocument(id: $id)
    }
`;

export const UPDATE_AGENT_BANKING_DETAILS = gql`
    mutation UpdateAgentBankingDetails($agentId: ID!, $input: BankingDetailsInput!) {
        updateAgentBankingDetails(agentId: $agentId, input: $input) {
            id
            bankName
            accountNumber
            accountType
            branchCode
            accountHolder
        }
    }
`;

